module.exports = __webpack_public_path__ + "img/Flag_of_Greece.cf9fcd30.svg";